"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
/**
 * finds the index of the next instance of character with the exception of being inside a string literal
 * e.g. looking for ")" symbol, but if it's inside a string literal we don't care about it
 *  ('weareinsideastringliteral)"stillinside)"'nowoutside")insideagain")
 *                             ^skipped     ^skipped      ^skipped     ^ found
 * @param {string} lookingFor character sequence being searched for
 * @param {number} returnWhenNotFound numeric value to return if not found (e.g.) -1, or Number.MAX_SAFE_INTEGER)
 * @returns {number} starting index of the character sequence, or returnWhenNotFound
 */
var getIndexOfNextSymbol = function (lookingFor, returnWhenNotFound) {
    if (returnWhenNotFound === void 0) { returnWhenNotFound = -1; }
    return function (expr) {
        // stack of strings or escaped strings e.g.g ', ", \', \", \\\', \\\", etc.
        var stack = [];
        // number of \ immediately preceding current char position
        var precendingConsecutiveEscapeChars = 0;
        // index of 'lookingFor' we are currently checking
        var lookingForMatchIx = 0;
        var charArr = expr.split(''); // faster than Array.from
        for (var i = 0; i < charArr.length; i++) {
            var cch = charArr[i];
            if (cch === '"' || cch === "'") {
                var qualifiedQuote = precendingConsecutiveEscapeChars % 2 === 0 ? cch : ('\\'.repeat(precendingConsecutiveEscapeChars)) + cch;
                var ixInStack = stack.indexOf(qualifiedQuote);
                if (ixInStack !== -1) {
                    stack.splice(ixInStack);
                }
                else {
                    stack.push(qualifiedQuote);
                }
            }
            if (stack.length === 0) {
                if (cch === lookingFor[lookingForMatchIx]) {
                    if (lookingForMatchIx + 1 === lookingFor.length) { // we reached a full match
                        return i - (lookingFor.length - 1);
                    }
                    lookingForMatchIx += 1;
                }
                else {
                    lookingForMatchIx = 0;
                }
            }
            if (cch === '\\') {
                precendingConsecutiveEscapeChars += 1;
            }
            else {
                precendingConsecutiveEscapeChars = 0;
            }
        }
        return returnWhenNotFound;
    };
};
exports.default = getIndexOfNextSymbol;
//# sourceMappingURL=getIndexOfNextSymbol.js.map